import React, { useState, useEffect } from 'react';
import API from '../api';
import { showError, showSuccess } from '../utils/dialog';

const ComposeEmailModal = ({ isOpen = false, onClose = () => {}, prefill = {} }) => {
	const [subject, setSubject] = useState(prefill.subject || '');
	const [body, setBody] = useState(prefill.body || '');
	const [recipients, setRecipients] = useState((prefill.recipients && prefill.recipients.join(',')) || '');
	const [isSending, setIsSending] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setSubject(prefill.subject || '');
			setBody(prefill.body || '');
			setRecipients((prefill.recipients && prefill.recipients.join(',')) || '');
		}
	}, [isOpen, prefill]);

	if (!isOpen) return null;

	const handleSend = async () => {
		const to = recipients
			.split(',')
			.map((s) => s.trim())
			.filter(Boolean)
			.join(',');
		if (!to) {
			showError('Recipient email is required');
			return;
		}
		setIsSending(true);
		try {
			const resp = await API.post('/api/admin/messages/send', {
				to,
				subject,
				body,
			});
			if (resp.data?.success) {
				showSuccess('Email sent');
				onClose();
			} else {
				showError(resp.data?.message || 'Failed to send email');
			}
		} catch (err) {
			console.error('Compose send error', err);
			showError('Failed to send email');
		} finally {
			setIsSending(false);
		}
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6">
				<div className="flex items-center justify-between mb-4">
					<h3 className="text-lg font-semibold">Compose Email</h3>
					<button onClick={onClose} className="text-sm text-gray-600">✖</button>
				</div>

				<div className="space-y-3">
					<div>
						<label className="block text-sm text-gray-700">To</label>
						<input value={recipients} onChange={(e) => setRecipients(e.target.value)} className="w-full border rounded px-3 py-2" />
						<div className="text-xs text-muted-foreground mt-1">Comma-separated emails</div>
					</div>

					<div>
						<label className="block text-sm text-gray-700">Subject</label>
						<input value={subject} onChange={(e) => setSubject(e.target.value)} className="w-full border rounded px-3 py-2" />
					</div>

					<div>
						<label className="block text-sm text-gray-700">Body</label>
						<textarea value={body} onChange={(e) => setBody(e.target.value)} className="w-full border rounded px-3 py-2 h-40" />
					</div>

					<div className="flex justify-end gap-3">
						<button onClick={onClose} className="px-4 py-2 border rounded">Cancel</button>
						<button onClick={handleSend} className="px-4 py-2 bg-buttonRed text-white rounded" disabled={isSending}>
							{isSending ? 'Sending...' : 'Send'}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ComposeEmailModal;
